import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Botton from "./Botton";

const Main: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const videoElement = document.querySelector("video");
    if (videoElement) {
      videoElement.muted = true; // Ensure the video is muted for autoplay to work
    }
  }, []);

  return (
    <div
      className="relative top-0 left-0 w-full h-[70vh] md:h-[80vh] text-white overflow-hidden z-20 bg-[#F3F4F5] bg-cover bg-center"
      style={{ backgroundImage: "url('/bg-contact.jpg')" }}
    >
      <div className="w-full h-full flex justify-center items-center relative">
        {/* Gradient overlay */}
        <div className="z-10 absolute inset-0 bg-gradient-to-b from-transparent to-[#11101066] opacity-45" />

        {/* Text container */}
        <div className="z-20 text-center animate-fadeInSlow px-4 sm:px-6 md:px-8">
          <h1 className="text-[#111010] text-5xl sm:text-4xl md:text-5xl lg:text-7xl my-2 font-bold">
            <img
              src="/letterP.png"
              alt="P"
              className="inline-block w-16 h-16 md:w-20 md:h-20  mb-5"
            />
            als Infotech
          </h1>
          <p className="text-gray-900 text-lg sm:text-base md:text-xl my-4 lg:my-6 lg:text-lg">
            What are you in the mood to build today?
          </p>
          <div className="flex flex-col sm:flex-row  mt-8 md:mt-0 space-y-4 sm:space-y-0 sm:space-x-5 items-center justify-center">
            <Link to="/contact">
              <Botton value="Contact us" size="lg" color={""} />
            </Link>
            <div className="group relative text-lg sm:text-xl md:text-2xl font-medium cursor-pointer text-center text-[#111010] hover:text-[#111010] transition duration-300">
              <Link to="/work">
                <button className="">See our Work</button>
              </Link>
              <span
                className="absolute left-0 top-full w-0 h-[2px] bg-gray-900 transition-all duration-300 ease-in-out group-hover:w-full"
                aria-hidden="true"
              ></span>
            </div>
          </div>
        </div>

        {/* Video background */}
      </div>
    </div>
  );
};

export default Main;
